import React, { FC, useContext } from 'react';
import { FormattedMessage } from 'react-intl';
import { LawyerAllDecisionsButton } from './LawyerAllDecisionsButton';
import { Hyperlink } from '../../../components/Hyperlink';
import { LawyerFollow } from './follow/LawyerFollow';
import { UserContext } from '../../../user/UserContext';
import styles from './lawyer_header_actions.module.scss';
import { MaterialIcon } from '../../../components/material-icon/MaterialIcon';
import { LawyerContext } from '../LawyerContext';

type Props = {
  isFollowButtonPresent: boolean;
};

export const LawyerHeaderActions: FC<Props> = ({ isFollowButtonPresent }) => {
  const { loggedIn } = useContext(UserContext);
  const { lawyerIsCurrentUser } = useContext(LawyerContext);
  return (
    <div className={styles.container}>
      {isFollowButtonPresent && <LawyerFollow />}
      <LawyerAllDecisionsButton />
      {loggedIn && lawyerIsCurrentUser && (
        <Hyperlink
          className="button secondary small-left"
          href="/profil/informations"
          source="professional_top"
        >
          <MaterialIcon name="mode_edit" />
          <FormattedMessage id="app.pages.lawyer.header.actions.modify" />
        </Hyperlink>
      )}
    </div>
  );
};
